module.exports = __webpack_public_path__ + "img/mobile_map_sevilla.2d4f7252.svg";